import Vue from 'vue';
import { Component, Prop, Provide, Watch } from 'vue-property-decorator';
import template from './paymentList.vue';
import UnisProductModal from '../../components/unisProductModal';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import tmsService from '../../services/axios/tmsService';
import AddPayment from '../../components/addPayment';
import switchBillingToService from '../../shared/switchBillingToService';
import tmsTransformRequestService from '../../services/axios/tmsTransformRequestService';
import qs from 'qs';
@Component({
    mixins: [template],
    components: {
        UnisProductModal,
        AddPayment,
    },
})
export default class PaymentList extends Vue {
    paymentList: any = [];
    showErrTip: boolean = false;
    errorText: String = '';
    editProductModal: string = 'addPayMethodDom';
    billToId: any = '';
    cardId: any = '';

    async mounted() {
        this.billToId = await this.getUserBillToId();
        if (this.billToId) {
            this.getPaymentList();
        } else {
            this.showErrorFun('BilltoId error.');
        }
    }

    closeModal() {
        this.$modal.hide(this.editProductModal);
    }

    getUserBillToId() {
        let params: any = {
            UserID: localStorage.UserID,
            UserToken: localStorage.UserToken,
        };
        return new Promise((resolve: any, reject: any) => {
            switchBillingToService.post().then(
                (res: any) => {
                    if (res.data.billing) {
                        res.data.billing.location_id;
                        resolve(res.data.billing.location_id);
                    } else {
                        resolve('');
                    }
                },
                (err: any) => {
                    reject('');
                    console.log(err);
                }
            );
        });
    }

    getPaymentList() {
        tmsServiceBackend
            .post(`/payment/getPaymentMethodList?billto_id=${this.billToId}&create_from=CLIENT`)
            .then(
                (res: any) => {
                    this.paymentList = res.data.data;
                },
                (err: any) => {
                    console.log(err);
                }
            );
    }

    showRemoveDialog(cardId: any) {
        this.cardId = cardId;
        this.editProductModal = 'showRemoveDialog';
        this.$modal.show(this.editProductModal);
    }

    removePayment() {
        tmsServiceBackend.post(`/payment/deletePaymentMethod/${this.cardId}`).then(
            (res: any) => {
                if (res.data.data.location_cx1_id) {
                    this.getPaymentList();
                    this.$modal.hide(this.editProductModal);
                } else {
                    this.showErrorFun('error');
                }
            },
            (err: any) => {
                this.showErrorFun(err);
            }
        );
    }

    addPayment() {
        this.editProductModal = 'addPayMethodDom';
        this.$modal.show(this.editProductModal);
    }

    addNewPayment() {
        this.getPaymentList();
        this.$modal.hide(this.editProductModal);
    }

    closeTips() {
        this.showErrTip = false;
    }

    showErrorFun(errText: any) {
        this.errorText = errText;
        this.showErrTip = true;
        setTimeout(() => {
            this.showErrTip = false;
        }, 3000);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/paymentList/index.ts